export const DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION =
  'DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION'
export const DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION_WORD =
  'DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION_WORD'
export const DELETE_COLLEGE_COUNSELLING_DOCUMENT = 'DELETE_COLLEGE_COUNSELLING_DOCUMENT'
export const DELETE_COLLEGE_COUNSELLING_PORTFOLIO = 'DELETE_COLLEGE_COUNSELLING_PORTFOLIO'
export const GET_COLLEGE_COUNSELLING_DOCUMENT_TYPES = 'GET_COLLEGE_COUNSELLING_DOCUMENT_TYPES'
export const GET_COLLEGE_COUNSELLING_PORTFOLIO = 'GET_COLLEGE_COUNSELLING_PORTFOLIO'
export const GET_COLLEGE_COUNSELLING_PORTFOLIOS = 'GET_COLLEGE_COUNSELLING_PORTFOLIOS'
export const GET_COLLEGE_COUNSELLING_PORTFOLIO_STATS = 'GET_COLLEGE_COUNSELLING_PORTFOLIO_STATS'
export const GET_COLLEGE_COUNSELLING_TEACHERS = 'GET_COLLEGE_COUNSELLING_TEACHERS'
export const GET_COLLEGE_COUNSELLING_TEACHER_REQUESTS = 'GET_COLLEGE_COUNSELLING_TEACHER_REQUESTS'
export const GET_EXTERNAL_RECOMMENDATION_REQUEST = 'GET_EXTERNAL_RECOMMENDATION_REQUEST'
export const GET_MY_COLLEGE_COUNSELLING_PORTFOLIO = 'GET_MY_COLLEGE_COUNSELLING_PORTFOLIO'
export const GET_MY_COLLEGE_COUNSELLING_PORTFOLIOS = 'GET_MY_COLLEGE_COUNSELLING_PORTFOLIOS'
export const REJECT_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST =
  'REJECT_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST'
export const RETURN_COLLEGE_COUNSELLING_PORTFOLIO = 'RETURN_COLLEGE_COUNSELLING_PORTFOLIO'
export const SET_COLLEGE_COUNSELLING_PORTFOLIO_STATUS = 'SET_COLLEGE_COUNSELLING_PORTFOLIO_STATUS'
export const SAVE_COLLEGE_COUNSELLING_ACADEMICS = 'SAVE_COLLEGE_COUNSELLING_ACADEMICS'
export const SAVE_COLLEGE_COUNSELLING_DESTINATIONS = 'SAVE_COLLEGE_COUNSELLING_DESTINATIONS'
export const SAVE_COLLEGE_COUNSELLING_DOCUMENT = 'SAVE_COLLEGE_COUNSELLING_DOCUMENT'
export const SAVE_COLLEGE_COUNSELLING_RECOMMENDATION_DRAFT =
  'SAVE_COLLEGE_COUNSELLING_RECOMMENDATION_DRAFT'
export const SAVE_COLLEGE_COUNSELLING_SECTION = 'SAVE_COLLEGE_COUNSELLING_SECTION'
export const SEND_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST =
  'SEND_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST'
export const START_COLLEGE_COUNSELLING_APPLICATION = 'START_COLLEGE_COUNSELLING_APPLICATION'
export const SUBMIT_COLLEGE_COUNSELLING_PORTFOLIO = 'SUBMIT_COLLEGE_COUNSELLING_PORTFOLIO'
export const SUBMIT_COLLEGE_COUNSELLING_RECOMMENDATION = 'SUBMIT_COLLEGE_COUNSELLING_RECOMMENDATION'
export const SUBMIT_EXTERNAL_RECOMMENDATION = 'SUBMIT_EXTERNAL_RECOMMENDATION'

export const DOWNLOAD_COLLEGE_COUNSELLING_APPLICATION_PDF =
  'DOWNLOAD_COLLEGE_COUNSELLING_APPLICATION_PDF'
